import styled from 'styled-components'

export const SectionGlobal = styled.section`
background-color: white;
display: flex;
justify-content: space-evenly;
align-items: center;
@media (min-width: 201px) and (max-width: 500px) {
    flex-direction: column;
}
`

export const SectionTabela = styled.section`
margin-top: 1rem;
width: 50%;
position: relative;
left: 1.5rem;
@media (min-width: 201px) and (max-width: 500px) {
    width: 100%;
    left: 0;
}
`

export const DivTabelaTitulo = styled.div`
display: flex;
p {
    font-size: 1.4rem;
    text-align: start;
    color: white;
    width: 100%;
    height: 4.5vh;
    background-image: linear-gradient(135deg, rgb(24, 24, 27) 0%, rgba(24, 24, 27, 0.8) 100%);
    padding-top: 0.1rem;
    padding-left: 0.5rem;
    font-weight: 600;
}
@media (min-width: 201px) and (max-width: 500px) {
   p {
    font-size: 0.7rem;
    height: 3vh;
   }
}
`
export const DivTabelaConteudo = styled.div`
margin-top: 1rem;
display: flex;
font-size: 1.1rem;
text-align: start;
p {
    width: 100%;
    padding-left: 0.5rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    font-size: 0.6rem;
}
`
export const ImgMeioFio = styled.img `
position: relative;
top: 1rem;
border-radius: 10px;
transform: scale(0.7);
@media (min-width: 201px) and (max-width: 500px) {
    transform: scale(0.45)
}
@media (min-width: 501px) and (max-width: 900px) {
    width: 40%;
    height: 25vh;
}
`